<template>
  <div class="model-trees-component">
    <div class="title">
      <span>Список модельных деревьев</span>
    </div>
    <table class="table-common model-table">
      <thead>
        <tr>
          <th>Номер площадки</th>
          <th>Ярус</th>
          <th>Порода</th>
          <th>Разряд высот</th>
          <th>Диаметр, см</th>
          <th>Высота, м</th>
          <th>Возраст</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(tree, tree_i) in modelTreeList">
          <td
            v-if="tree_i === plotNumMask[tree.plot_num].start"
            :rowspan="plotNumMask[tree.plot_num].count"
          >
            {{ tree.plot_num }}
          </td>
          <!-- <td v-if='tree_i === layerMask[tree.layer].start' :rowspan='layerMask[tree.layer].count'>{{ tree.layer }}</td> -->
          <td v-if="isLayerMask(tree, tree_i)" :rowspan="layerMaskCount(tree)">
            {{ tree.layer == 11 ? 'единичные деревья': tree.layer  }}
          </td>
          <td
            v-if="isSpeciesMask(tree, tree_i)"
            :rowspan="speciesMaskCount(tree)"
          >
            {{
              tree.species +
                (tree.gen !== "1" ? " (" + tree.gen + " поколение)" : "")
            }}
          </td>
          <!-- <td>{{ tree.species }}</td> -->
          <td
            v-if="isSpeciesMask(tree, tree_i)"
            :rowspan="speciesMaskCount(tree)"
          >
            {{ tree.h_degree }}
          </td>
          <!-- <td>{{ tree.d }}</td> -->
          <td>
            <input
              :disabled="!modelTreesAreOpen"
              type="number"
              v-model="values[tree_i].d"
              @input="setValuesHeightForSpecies(values[tree_i], tree)"
              :class="{ 'not-match': !isMatch(tree_i, 'd') }"
            />
          </td>
          <!-- <td v-if='isDMask(tree, tree_i)' :rowspan='dMaskCount(tree)'>{{ tree.d }}</td> -->
          <td>
            <input
              :disabled="!modelTreesAreOpen"
              type="number"
              v-model="values[tree_i].height"
              @input="setValuesHeightForSpecies(values[tree_i], tree)"
              :class="{ 'not-match': !isMatch(tree_i, 'height') }"
            />
          </td>
          <td>
            <input
              :disabled="!modelTreesAreOpen"
              type="number"
              v-model="values[tree_i].age"
              @input="setValuesAgeForSpecies(values[tree_i], tree)"
              :class="{ 'not-match': !isMatch(tree_i, 'age') }"
            />
          </td>
        </tr>
      </tbody>
    </table>

    <!-- <span>model trees exist: {{ modelTreesExist }}</span><br> -->
    <div class="btn-block">
      <!-- <button @click='test'>test</button> -->
      <button v-if="notMatchedExists" @click="save">Сохранить</button>
      <button :disabled="!actLpoIsDraft" v-if="allValuesValid" @click="toggle">
        {{
          modelTreesAreOpen
            ? "Закрыть редактирование"
            : "Открыть редактирование"
        }}
      </button>
    </div>

    <!-- {{ speciesMask }} -->
    <!-- {{ dMask }} -->
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "RecountModelTrees",
  data() {
    return {
      values: [],
    };
  },
  computed: {
    actLpoIsDraft() {
      return this.$store.getters["lpoData/actLpoIsDraft"];
    },

    modelTreeList() {
      return this.$store.state.selectedLpo.recount["modelTreeList"];
    },
    modelTreesExist() {
      return this.$store.getters["selectedLpo/recount/modelTreesExist"];
    },

    modelTreesAreOpen() {
      return this.$store.getters["selectedLpo/recount/modelTreesAreOpen"];
    },

    hDegreeList() {
      return this.$store.state.selectedLpo.recount["hDegreeList"];
    },

    notMatchedExists() {
      for (let i = 0; i < this.modelTreeList.length; ++i) {
        if (
          !this.isMatch(i, "height") ||
          !this.isMatch(i, "age") ||
          !this.isMatch(i, "d")
        ) {
          return true;
        }
      }
      return false;
    },

    allValuesValid() {
      for (const tree of this.modelTreeList) {
        if (+tree.height < 1 || +tree.age < 1) {
          return false;
        }
      }
      return true;
    },

    /* TABLE MASKS */
    plotNumMask() {
      const result = {};

      for (let i = 0; i < this.modelTreeList.length; ++i) {
        const tree = this.modelTreeList[i];

        if (!result[tree.plot_num]) {
          result[tree.plot_num] = {
            start: i,
            count: 1,
          };
        } else {
          result[tree.plot_num].count++;
        }
      }
      // console.log(JSON.stringify(result, null, 2));
      return result;
    },

    layerMask() {
      const result = [];

      for (let i = 0; i < this.modelTreeList.length; ++i) {
        const tree = this.modelTreeList[i];

        const finded = result.find(
          (item) => item.layer === tree.layer && item.plot_num === tree.plot_num
        );

        if (!finded) {
          const temp = {
            layer: tree.layer,
            plot_num: tree.plot_num,
            start: i,
            count: 1,
          };

          result.push(temp);
        } else {
          finded.count++;
        }
      }
      // console.log(JSON.stringify(result, null, 2));
      return result;
    },

    speciesMask() {
      const result = [];

      for (let i = 0; i < this.modelTreeList.length; ++i) {
        const tree = this.modelTreeList[i];

        // console.log('tree species:', tree.species_id);

        const finded = result.find(
          (item) =>
            item.species_id === tree.species_id &&
            item.layer === tree.layer &&
            item.gen === tree.gen &&
            item.plot_num === tree.plot_num
        );

        // console.log(finded);

        if (!finded) {
          const temp = {
            plot_num: tree.plot_num,
            species_id: tree.species_id,
            layer: tree.layer,
            gen: tree.gen,
            start: i,
            count: 1,
          };
          result.push(temp);
        } else {
          finded.count++;
        }
      }
      // console.log(JSON.stringify(result, null, 2));
      return result;
    },
    dMask() {
      const result = [];

      for (let i = 0; i < this.modelTreeList.length; ++i) {
        const tree = this.modelTreeList[i];

        // console.log('tree species:', tree.species_id);

        const finded = result.find(
          (item) =>
            item.species_id === tree.species_id &&
            item.layer === tree.layer &&
            item.gen === tree.gen &&
            item.d === tree.d
        );

        // console.log(finded);

        if (!finded) {
          const temp = {
            species_id: tree.species_id,
            layer: tree.layer,
            gen: tree.gen,
            d: tree.d,
            start: i,
            count: 1,
          };
          result.push(temp);
        } else {
          finded.count++;
        }
      }
      // console.log(JSON.stringify(result, null, 2));
      return result;
    },
  },
  watch: {
    modelTreeList() {
      this.setValues();
    },
  },
  methods: {
    test() {
      console.log(this.values);
    },

    isLayerMask(tree, tree_i) {
      const finded = this.layerMask.find(
        (item) => item.layer === tree.layer && item.plot_num === tree.plot_num
      );
      return tree_i === finded.start;
    },
    layerMaskCount(tree) {
      const finded = this.layerMask.find(
        (item) => item.layer === tree.layer && item.plot_num === tree.plot_num
      );
      return finded.count;
    },

    isSpeciesMask(tree, tree_i) {
      const finded = this.speciesMask.find(
        (item) =>
          item.species_id === tree.species_id &&
          item.layer === tree.layer &&
          item.gen === tree.gen &&
          item.plot_num === tree.plot_num
      );
      return tree_i === finded.start;
    },
    speciesMaskCount(tree) {
      const finded = this.speciesMask.find(
        (item) =>
          item.species_id === tree.species_id &&
          item.layer === tree.layer &&
          item.gen === tree.gen &&
          item.plot_num === tree.plot_num
      );
      return finded.count;
    },

    isDMask(tree, tree_i) {
      const finded = this.dMask.find(
        (item) =>
          item.species_id === tree.species_id &&
          item.layer === tree.layer &&
          item.gen === tree.gen &&
          item.d === tree.d
      );
      return tree_i === finded.start;
    },
    dMaskCount(tree) {
      const finded = this.dMask.find(
        (item) =>
          item.species_id === tree.species_id &&
          item.layer === tree.layer &&
          item.gen === tree.gen &&
          item.d === tree.d
      );
      return finded.count;
    },

    isMatch(tree_i, value_name) {
      return (
        +this.modelTreeList[tree_i][value_name] ===
        +this.values[tree_i][value_name]
      );
    },

    setValuesHeightForSpecies(tree, tree_real) {
      for (const tree_value of this.values) {
        if (
          tree_value.species_id === tree.species_id &&
          tree_value.layer === tree.layer &&
          tree_value.gen === tree.gen &&
          tree_value.d === tree.d
        ) {
          if (tree_real.height === "0" || !tree_real.height) {
            tree_value.height = tree.height;
          }
        }
      }
    },
    setValuesAgeForSpecies(tree, tree_real) {
      for (const tree_value of this.values) {
        if (
          tree_value.species_id === tree.species_id &&
          tree_value.layer === tree.layer &&
          tree_value.gen === tree.gen &&
          tree_value.d === tree.d
        ) {
          if (tree_real.age === "0" || !tree_real.age) {
            tree_value.age = tree.age;
          }
        }
      }
    },

    setValues() {
      const result = [];

      for (const tree of this.modelTreeList) {
        const temp = {
          id: tree.id,
          plot_num: tree.plot_num,
          height: tree.height,
          age: tree.age,
          d: tree.d,
          layer: tree.layer,
          gen: tree.gen,
          is_draft: tree.is_draft === "t" ? true : false,
          species_id: tree.species_id,
        };
        result.push(temp);
      }

      this.values = result;
    },

    // getHDegree(tree) {
    // 	const findedDegree = this.hDegreeList.find(degree => degree.species_id === tree.species_id);
    // 	return findedDegree ? findedDegree.h_degree : null;
    // },

    save() {
      this.saveModelTreeList(this.values).then((res) => {
        this.updateModelTreeList();
      });
    },

    toggle() {
      this.toggleModelTrees().then((res) => {
        this.updateModelTreeList();
      });
    },

    ...mapActions("selectedLpo/recount", [
      "saveModelTreeList",
      "toggleModelTrees",
      "updateModelTreeList",
    ]),
  },
  created() {
    this.setValues();
  },
};
</script>

<!-- <style scoped src='@/style/table.css'></style> -->

<style scoped>
.model-trees-component {
  margin-top: 50px;
}

.title {
  font-size: 1rem;
  font-weight: bold;
  font-style: italic;
  margin-bottom: 10px;
}

input.not-match {
  background-color: orange;
}

table th,
table td {
  /*border: 1px solid black;*/
}

.model-table th {
  border-bottom: 2px solid black;
  font-weight: bold;
  padding: 6px 20px;
}
.model-table td {
  border-bottom: 1px solid black;
  border-left: 1px solid #ccc;
  border-right: 1px solid #ccc;
  padding: 8px;
  text-align: center;
  vertical-align: middle;
}

.btn-block {
  margin-top: 10px;
}
.btn-block > button:not(:last-child) {
  margin-right: 6px;
}
</style>
